import IConfigSettings from './IConfigSettings';

interface IEnvironmentConfig {
  apiLocation: string;
  configSettings: IConfigSettings;
}

// Shared keys across all environments
const RECAPTCHA_KEY = '6LcuRaUUAAAAAFcSmqegK7mP4DDGoxiwGuBUh98L';
const GOOGLE_OAUTH_KEY = '559060309214-qbi1pdhjdqi5aifngntoaeljuaia216h.apps.googleusercontent.com';

const buildConfig = (apiLocation: string, recaptchaEnabled: boolean): IEnvironmentConfig => ({
  apiLocation,
  configSettings: {
    RecaptchaEnabled: recaptchaEnabled,
    RecaptchaKey: RECAPTCHA_KEY,
    GoogleOAuthKey: GOOGLE_OAUTH_KEY,
  },
});

// Environment definitions
const local = buildConfig('http://localhost:5000/api', false);
const dev = buildConfig('https://wholesale-dev-api.orderly.io/api', false);
const qa = buildConfig('https://wholesale-qa-api.orderly.io/api', false);
const uat = buildConfig('https://uat-ordermanagement.orderly.io/api', true);
const prod = buildConfig('https://wholesale-api.orderly.io/api', true);

/**
 * Static environment configuration keyed by hostname.
 * Replaces the runtime apilocator service call.
 */
const environmentMap: Record<string, IEnvironmentConfig> = {
  localhost: local,
  'morrisons-wholesale-dev.azurewebsites.net': dev,
  'morrisons-wholesale-qa.azurewebsites.net': qa,
  'morrisons-wholesale-uat.azurewebsites.net': uat,
  'morrisons-wholesale-uat-v2.azurewebsites.net': uat,
  'morrisons-wholesale-test.orderly.io': uat,
  'morrisons-wholesale-uat-app-d7c7d7g9f8h9hzau.uksouth-01.azurewebsites.net': uat,
  'wholesale.uat.np.morconnect.com': uat,
  'morrisons-wholesale.azurewebsites.net': prod,
  'morrisons-wholesale-v2.azurewebsites.net': prod,
  'wholesale.morrisons.com': prod,
};

/**
 * Resolves the environment config for the current hostname.
 * Throws if the hostname is not recognised.
 */
export const getEnvironmentConfig = (hostname: string): IEnvironmentConfig => {
  const config = environmentMap[hostname];

  if (!config) {
    throw new Error(
      `Unknown environment hostname: "${hostname}". ` +
      'Add it to environmentConfig.ts to configure this environment.',
    );
  }

  return config;
};
